import type Locale from 'date-fns/locale';
import * as Locales from 'date-fns/locale';

export const getDateFnsLocale = (code: string): Locale => {
  const [lang, country] = code.split('-');
  // date-fns keys the region fully uppercased (`enUS`, `enGB`); anything else
  // falls back to the language-only default.
  const region = country ? country.toUpperCase() : '';
  return Locales[lang + region] ? Locales[lang + region] : Locales[lang];
};
